import { ApiError } from '../services/apiClient';
import { isValidRole } from '../config/roles';

// Only trust the fields we need, and only roles we know. Anything else means "not signed in".
export function toSessionUser(raw) {
  if (!raw || raw.id === undefined || raw.id === null || !isValidRole(raw.role)) {
    throw new ApiError({ message: 'Your session is not valid. Please sign in again.', status: 401, code: 'INVALID_SESSION' });
  }
  return Object.freeze({
    id: String(raw.id),
    role: raw.role,
    name: String(raw.name || raw.fullName || ''),
    email: String(raw.email || ''),
    phone: raw.phone ? String(raw.phone) : '',
    emailVerified: Boolean(raw.emailVerified),
    verification: raw.verification || undefined,
  });
}
